function customVideoDivMouseDownMobile(event,url){
        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?enablejsapi=1&autoplay=1&fs=1&playsinline=0" class="youtube-player youtubeVideo  customVideoListYoutubeVideoMobile" frameborder="0" ></iframe>';
        $(".youtubeVideoMobileDiv").prepend(videoHtml);
        $(".videoPopupShowMobileDiv").show();
    }

    $(".video-close-mobile").click(function() {
        $(".videoPopupShowMobileDiv").hide();
        $(".customVideoListYoutubeVideoMobile").remove();
    })

    var swiper = new Swiper("#customVideoListMobileSwiper", {
        slidesPerView: 'auto',
        preventClicks:'false',
        spaceBetween: 8,
        // freeMode: {
        //     enabled: true,
        //     sticky: true,
        // },
    });
    /*=================== 拖拽 =================== */
    // var customVideoListMobileMoveDiv = $('.customVideoListMoveMobileDiv');
    // var animateFlag = false;
    // var customVideoListMobileIsKeyDown = false;
    // var customVideoListMobileMoveX = 0;
    // var customVideoListMobileCurrentX;
    // var customVideoListMobileTriggerCurrentX;
    // var customVideoListMobileTriggerMoveX;
    // var customVideoListMobileClickHref;
    // var customVideoListMobileClickUrl;
    // var customVideoListMobileIndex = 1;
    // var customVideoListMobileWidth = $(".customVideoMobileDiv").outerWidth(true);
    // var customVideoListMobileCount = $(".customVideoMobileDiv").length;
    // var customVideoListMobileMaxCount = parseInt(window.screen.width / customVideoListMobileWidth);
    // var customVideoListMobileMaxLeft =((customVideoListMobileWidth + 8) * customVideoListMobileCount - 8 + 80) - window.screen.width;;
    //
    // // 监听按下
    // customVideoListMobileMoveDiv.on('touchstart mousedown',function (e) {
    //     customVideoListMobileIsKeyDown = true;
    //     if (e.type === 'mousedown'){
    //         customVideoListMobileCurrentX = e.clientX;
    //         customVideoListMobileTriggerCurrentX = e.clientX;
    //     }else if (e.type === 'touchstart'){
    //         customVideoListMobileCurrentX = e.originalEvent.changedTouches[0].clientX;
    //         customVideoListMobileTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
    //
    //     }
    //
    // });
    // function customVideoDivMouseDownMobile(event,url){
    //     var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?fs=1" class="youtube-player youtubeVideo  customVideoListYoutubeVideo" frameborder="0"></iframe>';
    //     $(".youtubeVideoMobileDiv").prepend(videoHtml);
    //     $(".videoPopupShowMobileDiv").show();
    // }
    //
    // // 监听鼠标移动事件
    // customVideoListMobileMoveDiv.on('touchmove mousemove',function (e) {
    //     if (customVideoListMobileIsKeyDown) {
    //         // 计算移动距离
    //         if (e.type === 'mousemove'){
    //             customVideoListMobileMoveX = parseInt(e.clientX) -  parseInt(customVideoListMobileCurrentX);
    //             customVideoListMobileTriggerMoveX =  parseInt(e.clientX) -  parseInt(customVideoListMobileTriggerCurrentX);
    //             // 重要！ 准确记录每次触发的移动量
    //             customVideoListMobileTriggerCurrentX = e.clientX;
    //         }else if (e.type === 'touchmove'){
    //             customVideoListMobileMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(customVideoListMobileCurrentX);
    //             customVideoListMobileTriggerMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(customVideoListMobileTriggerCurrentX);
    //             // 重要！ 准确记录每次触发的移动量
    //             customVideoListMobileTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
    //         }
    //         if (customVideoListMobileTriggerMoveX === 0 || customVideoListMobileTriggerMoveX === 0) {
    //             return;
    //         }
    //         if (customVideoListMobileTriggerMoveX > 0){
    //             customVideoListMobileMoveDiv.stop().animate({left: "+=" + customVideoListMobileTriggerMoveX * 1.8 + "px"}, 0, function() {
    //             });
    //         }else if(customVideoListMobileTriggerMoveX < 0){
    //             customVideoListMobileMoveDiv.stop().animate({left: "+=" + customVideoListMobileTriggerMoveX * 1.8 + "px"}, 0, function() {
    //             });
    //         }
    //     }
    //
    //
    // })
    //
    // // 监听抬起
    // customVideoListMobileMoveDiv.on('touchend mouseup',function (e) {
    //     if (customVideoListMobileIsKeyDown){
    //
    //         customVideoListMobileIsKeyDown = false;
    //
    //         if (customVideoListMobileMoveX === 0 && customVideoListMobileClickHref != null && customVideoListMobileClickHref.toString() != 'undefined') {
    //             window.location.href = customVideoListMobileClickHref;
    //             return;
    //         }
    //
    //
    //
    //         customVideoListMobileMoveX = customVideoListMobileMoveX * 1.8;
    //
    //
    //         // 超出的距离（余数）
    //         var moveCount =Math.round(Math.abs(parseInt(customVideoListMobileMoveX)) / parseInt(customVideoListMobileWidth));
    //
    //
    //         var overX =Math.abs(parseInt(customVideoListMobileMoveX)) % parseInt(customVideoListMobileWidth);
    //         var currentLeft = customVideoListMobileMoveDiv.css('left');
    //
    //
    //         if (overX > (customVideoListMobileWidth / 5) && parseInt(currentLeft) <= 0){
    //
    //             if ((parseInt(currentLeft) + customVideoListMobileMoveX + overX ) * -1 > customVideoListMobileMaxLeft){
    //                 customVideoListMobileMoveDiv.stop().animate({left: customVideoListMobileMaxLeft * -1 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * customVideoListMobileWidth) ) >= 0 && customVideoListMobileMoveX > 0){
    //                 customVideoListMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * customVideoListMobileWidth  * -1)) >= 0 && customVideoListMobileMoveX < 0){
    //                 customVideoListMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else {
    //                 if (customVideoListMobileMoveX > 0){
    //                     customVideoListMobileMoveDiv.stop().animate({left: (customVideoListMobileIndex - moveCount - 1) * customVideoListMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }else {
    //                     customVideoListMobileMoveDiv.stop().animate({left: (customVideoListMobileIndex + moveCount  - 1 ) * customVideoListMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }
    //
    //             }
    //
    //         }else if (parseInt(currentLeft) <= 0){
    //             // 反之
    //             if ((parseInt(currentLeft) + customVideoListMobileMoveX ) * -1 > customVideoListMobileMaxLeft){
    //                 customVideoListMobileMoveDiv.stop().animate({left: customVideoListMobileMaxLeft  * -1 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * customVideoListMobileWidth * -1) ) >= 0 && customVideoListMobileMoveX > 0){
    //                 customVideoListMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * customVideoListMobileWidth ) ) >= 0 && customVideoListMobileMoveX < 0){
    //                 customVideoListMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else{
    //                 if (customVideoListMobileMoveX > 0){
    //
    //                     customVideoListMobileMoveDiv.stop().animate({left: (customVideoListMobileIndex - moveCount - 1) * customVideoListMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //
    //                 }else{
    //
    //                     customVideoListMobileMoveDiv.stop().animate({left: (customVideoListMobileIndex + moveCount - 1 ) * customVideoListMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }
    //             }
    //
    //
    //         }else {
    //             customVideoListMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                 animateFlag = false;
    //             });
    //         }
    //
    //         sleep(350).then(() => {
    //
    //             customVideoListMobileIndex = Math.floor(parseInt(customVideoListMobileMoveDiv.css('left')) * -1 / parseInt(customVideoListMobileWidth) + 1);
    //         })
    //
    //         // 重置位移数，防止连点移动
    //         customVideoListMobileMoveX = 0;
    //
    //     }
    //     else if (customVideoListMobileIsKeyDown) {
    //         if (customVideoListMobileMoveX === 0 && customVideoListMobileClickHref != null && customVideoListMobileClickHref.toString() != 'undefined') {
    //             console.log('aaa')
    //             var videoHtml = '<iframe width="100%" height="100%" src="' + customVideoListMobileClickHref + '?fs=1" class="youtube-player youtubeVideo  customVideoListYoutubeVideo" frameborder="0"></iframe>';
    //             $(".youtubeVideoMobileDiv").prepend(videoHtml);
    //             $(".videoPopupShowMobileDiv").show();
    //             return;
    //
    //         }
    //     }
    //
    // });